/* Header.js */
import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import { CartContext } from "../contexts/CartContext";
import { ClientNameContext } from "../contexts/clientNameContext";

import { Container, Navbar, Nav, Form, FormControl, Button, Col, Row, Dropdown, ButtonGroup} from "react-bootstrap";
import logo from "../assets/img/logo.webp";
import { SvgBag, SvgBag2, SvgUser, SvgUser2, SvgSearch } from "./Svgs";
import NavbarCategories from "./NavbarCategories";

import ptFlag from '../assets/flags/pt.webp';
import deFlag from '../assets/flags/de.webp';
import enFlag from '../assets/flags/en.webp';

import { useTranslation } from 'react-i18next';

function Header() {
  const { t } = useTranslation();
  const { clientName, setClientName } = useContext(ClientNameContext);

  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };


  useEffect(() => {
    const storedClientName = localStorage.getItem("clientName");
    if (storedClientName) {
      setClientName(storedClientName);
    }
  }, [setClientName]);

  const { totalQuantityHeader } = useContext(CartContext);

  // pesquisa
  const [searchTerm, setSearchTerm] = useState(""); // Define o estado local do termo de busca
  const navigate = useNavigate(); // Hook para navegação

  // Manipulador de envio do formulário
  const handleSearch = (event) => {
    event.preventDefault();
    if (!searchTerm.trim()) {
      navigate(`/search/`); // Redireciona para a página com todos os produtos
      return;
    }
    navigate(`/search/${searchTerm.trim()}`); // Redireciona para a pesquisa com o termo
  };

  return (
    <header>
      <Navbar>
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand>
              <img
                alt="LM Brasil"
                src={logo}
                className="d-inline-block align-top img-fluid"
                width="110"
                height="113"
              />{" "}
            </Navbar.Brand>
          </LinkContainer>

          <div className='languages-menu'>
            <div onClick={() => changeLanguage('pt-BR')} className="language-option">
              <img src={ptFlag} alt="Português" className="flag-icon" />
            </div>            
            
            <div onClick={() => changeLanguage('de-DE')} className="language-option">
              <img src={deFlag} alt="Deutsch" className="flag-icon" />
            </div>

            <div onClick={() => changeLanguage('en_US')} className="language-option">
              <img src={enFlag} alt="English" className="flag-icon" />
            </div>
          </div>

          <Nav className="nav-links justify-content-end">
            <LinkContainer to="/cart">
              <Nav.Link>
                {totalQuantityHeader ? (
                  <div className="bag">
                    <SvgBag2 />
                    <div className="bag-bg-number">
                      <div className="bag-number">{totalQuantityHeader}</div>
                    </div>
                  </div>
                ) : (
                  <div className="bag">
                    <SvgBag />
                    <div className="bag-bg-number">
                      <div className="bag-number">{totalQuantityHeader}</div>
                    </div>
                  </div>
                )}
              </Nav.Link>
            </LinkContainer>

            {clientName ? (
              <Dropdown as={ButtonGroup}>
                <Dropdown.Toggle as={Nav.Link} id="dropdown-customer" className="p-0">
                  <SvgUser2 />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item as={Link} to="/previous-purchases">
                    {t('your_purchases')}
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/update-client">
                    {t('update_details')}
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/logout">
                    {t('logout')}
                  </Dropdown.Item>
                  <hr></hr>
                  <Dropdown.ItemText>
                    {t('hello')} {clientName}!
                  </Dropdown.ItemText>
                </Dropdown.Menu>
              </Dropdown>

            ) : (
              <LinkContainer to="/login">
                <Nav.Link>
                  <SvgUser />
                </Nav.Link>
              </LinkContainer>
            )}
          </Nav>
        </Container>
      </Navbar>

      <Container>
        <Row>
          <Col>

            <Form
              onSubmit={handleSearch} // Chama o manipulador no envio
              className="form-search"
            >
              <FormControl
                type="text"
                autoComplete="off"
                name="search"
                placeholder="Digite sua busca"
                className="textfield-search"
                value={searchTerm} // Liga o estado ao campo de texto
                onChange={(event) => setSearchTerm(event.target.value)} // Atualiza o estado
              />
              <Button variant="primary bt-search" type="submit">
                <SvgSearch />
              </Button>
            </Form>

          </Col>
        </Row>
      </Container>

      <Container className="navbar-categories">
        <NavbarCategories />
      </Container>
    </header>
  );
}

export default Header;
